import { toRoundedCommaSeparated } from '~/utils/number';
import FormattedMeasurement, {
  CommonFormattedMeasurementProps,
} from './FormattedMeasurement';

export default function FormattedPounds({
  formatter = toRoundedCommaSeparated,
  ...props
}: CommonFormattedMeasurementProps) {
  return (
    <FormattedMeasurement
      {...props}
      formatter={formatter}
      unitName="pound"
      unitAbbr="lb"
      unitPluralName="pounds"
      unitPluralAbbr="lbs"
    />
  );
}
